<template>
  <div class="rounded-2xl border mb-12 w-full">
    <coverImage
      :isOpen="isPopupCoverImage"
      @close="togglePopupcoverImage"
      :data="userData"
    />
    <profileImage
      :isOpen="isPopupProfileImage"
      @close="togglePopupProfileImage"
      :data="userData"
    />
    <div class="w-full relative">
      <!-- <img
        v-if="profileData.length===0 && profileData[0].coverimage.valueof ===null"
        src="@/assets/images/wgrid4.jpg"
        class="w-full h12 rounded-t-2xl"
      /> -->
      <img
        v-if="
          profileData.length &&
          profileData[0].coverimage != 'null' &&
          profileData[0].coverimage != undefined
        "
        :src="$imageURL + '/' + profileData[0].coverimage"
        class="w-full h12 rounded-t-2xl object-cover"
      />

      <img
        v-else
        src="@/assets/images/wgrid6.jpg"
        class="w-full h12 rounded-t-2xl object-cover"
      />

      <div class="absolute top-0 right-0 rounded-full">
        <b-dropdown
          no-caret
          size="lg"
          variant="link"
          right
          toggle-class="text-decoration-none z-10 text-transparent hover:text-transparent"
          id="dropdown-1"
          class=""
        >
          <template #button-content>
            <div class="bg-primary p-3 rounded-md">
              <feather-icon
                icon="Edit2Icon"
                class="cursor-pointer text-white"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </div>
          </template>
          <b-dropdown-item @click="isPopupCoverImage = true"
            >Edit</b-dropdown-item
          >
          <b-dropdown-item @click="deletecoverImage">Delete</b-dropdown-item>
        </b-dropdown>
      </div>

      <div
        class="profilephoto flex justify-center w-full rounded-full absolute"
      >
        <div class="relative rounded-full h-28 w-28 border6 olv">
          <img
            v-if="
              profileData.length &&
              profileData[0].image != 'null' &&
              profileData[0].image != undefined
            "
            :src="$imageURL + '/' + profileData[0].image"
            class="object-cover w-full h-full rounded-full profimage"
          />
          <img
            v-else
            src="@/assets/images/courses/7.png"
            class="object-cover w-full h-full rounded-full profimage"
          />

          <!-- default image -->
          <!-- <img
                      src="@/assets/images/blank-profile.png"
                      alt=""
                      class="object-cover w-full h-full rounded-full profimage"
                    
                    /> -->
          <div
            class="absolute flex top-5 w-full justify-center middle rounded-full p-2"
          >
            <b-dropdown
              size="lg"
              variant="link"
              toggle-class="text-decoration-none  text-transparent hover:text-transparent"
              no-caret
              id="dropdown-1"
            >
              <template #button-content>
                <div class="bg-primary p-2 rounded-md">
                  <feather-icon
                    icon="Edit2Icon"
                    class="cursor-pointer text-white"
                    svgClasses="w-5 h-5"
                  ></feather-icon>
                </div>
              </template>
              <b-dropdown-item @click="isPopupProfileImage = true">
                Edit</b-dropdown-item
              >
              <b-dropdown-item @click="deletePofile">Delete</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mt-16 w-3/5 mx-auto">
      <p class="font-semibold text-black">{{ fullName }}</p>
      <span class="text-sm">{{ Designation }}</span>
      <b-badge
        pill
        v-if="getUserByUserId.currentMembership"
        variant="success"
        class="text-sm"
        >{{ getUserByUserId.currentMembership.name }}</b-badge
      >
      <b-badge pill v-else variant="danger" class="text-sm">{{
        "No Plan"
      }}</b-badge>
    </div>
    <div class="flex justify-center pb-5">
      <b-badge pill variant="info" class="mt-8">{{
        role == "student" ? "Registered User" : role
      }}</b-badge>
    </div>
    <!-- <div class="flex justify-around my-8 w-4/5 mx-auto">
      <div class="border-2 p-2 rounded-lg">
        <feather-icon
          icon="LinkedinIcon"
          class="cursor-pointer my-auto text-black"
        ></feather-icon>
      </div>
      <div class="border-2 p-2 rounded-lg">
        <feather-icon
          icon="LinkedinIcon"
          class="cursor-pointer my-auto text-black"
        ></feather-icon>
      </div>
      <div class="border-2 p-2 rounded-lg">
        <feather-icon
          icon="LinkedinIcon"
          class="cursor-pointer my-auto text-black"
        ></feather-icon>
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import coverImage from "./tabs/components/coverImage.vue";
import profileImage from "./tabs/components/profileImage.vue";
export default {
  data() {
    return {
      isPopupCoverImage: false,
      isPopupProfileImage: false,
      // datainfo: {},
    };
  },

  components: {
    coverImage,
    profileImage,
  },
  methods: {
    async deletePofile() {
      let FormData = require("form-data");
      let payload = new FormData();
      payload.append("_id", this.userData._id);
      payload.append("image", null);

      this.$swal.fire({
        text: " Profile Image deleted successfully",
        icon: "success",
        confirmButtonText: "Okay",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });

      await this.$store.dispatch("eLearning/editUser", payload);
    },

    async deletecoverImage() {
      let FormData = require("form-data");
      let payload = new FormData();
      payload.append("_id", this.userData._id);
      payload.append("coverimage", null);

      this.$swal.fire({
        text: " Cover Image deleted successfully",
        icon: "success",
        confirmButtonText: "Okay",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });

      await this.$store.dispatch("eLearning/editUser", payload);
    },

    togglePopupcoverImage(val = false) {
      this.isPopupCoverImage = val;
    },

    togglePopupProfileImage(val = false) {
      this.isPopupProfileImage = val;
    },
    // async init() {
    //   this.datainfo = this.profileData[0];
    // },
  },
  // watch: {
  //   profileData(val) {
  //     if (val) {
  //       this.init();
  //     }
  //   },
  // },
  async mounted() {
    await this.$store.dispatch("eLearning/getProfile", {
      userId: this.userData._id,
    });
    await this.$store.dispatch("auth/getUserByUserId", {
      userId: this.userData._id,
    });
    // this.init();
  },
  computed: {
    ...mapState("auth", ["userData", "getUserByUserId"]),
    ...mapState("eLearning", { profileData: "profileData" }),

    isStudent() {
      return this.userData.role === "student";
    },
    profileImage() {
      return this.isStudent
        ? this.userData.student.profilePhoto
        : this.userData.author.profilePhoto;
    },
    coverImage() {
      return this.isStudent
        ? this.userData.student.coverPhoto
        : this.userData.author.coverPhoto;
    },
    fullName() {
      return `${this.userData.firstname} ${this.userData.lastname}`;
    },
    role() {
      return this.userData.role;
    },
    Designation() {
      if (this.userData.student) {
        return this.userData.student.designation;
      } else {
        return this.userData.designation;
      }
    },
    magittUrl() {
      return this.$imageURL;
    },
  },
};
</script>
